type SubFacilityLike = {
  name: string;
  subFacilityAddresses: Array<{
    displayId?: number | null;
    name: string;
    address?: string | null;
    contactPhone?: string | null;
  }>;
};

type CommunityLike = {
  subFacilities?: SubFacilityLike[] | null;
};

export type GroupedCustomer = {
  id: number;
  name: string;
  address: string;
  contactPhone: string;
  customerName?: string;
  subFacilityAddressId?: number;
};

export function mapCommunityCustomers(data: CommunityLike | null | undefined): GroupedCustomer[] {
  if (!data?.subFacilities) return [];

  return data.subFacilities.flatMap((subFacility) =>
    (subFacility.subFacilityAddresses ?? []).map((address) => {
      const id = address.displayId ?? 0;
      return {
        id,
        name: address.name ?? '',
        address: address.address ?? '',
        contactPhone: address.contactPhone ?? '',
        customerName: subFacility.name,
        subFacilityAddressId: id,
      };
    }),
  );
}
